import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import styled from "styled-components";

const StyledPill = styled(EmbeddedLink)<{ $isCountryFlag?: boolean }>`
  display: flex;
  align-items: center;
  padding: 4px 16px 4px 4px;
  height: ${getSpacing("5x")};
  margin-right: ${getSpacing("2x")};
  border-radius: 50px;
  background-color: ${Core.surface.muted};
  white-space: nowrap;

  &,
  &:hover,
  &:focus,
  &:focus-within {
    text-decoration: none;
  }

  img {
    display: block;
    border-radius: ${({ $isCountryFlag }) => ($isCountryFlag ? "0" : "50%")};
    width: ${({ $isCountryFlag }) =>
      $isCountryFlag
        ? PillStyles.COUNTRY_FLAG_WIDTH
        : PillStyles.SQUARE_DIMENSION}px;
    height: ${({ $isCountryFlag }) =>
      $isCountryFlag
        ? PillStyles.COUNTRY_FLAG_HEIGHT
        : PillStyles.SQUARE_DIMENSION}px;
    margin-left: ${({ $isCountryFlag }) => ($isCountryFlag ? "8px" : "0px")};
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    &:hover {
      border-color: ${Core.border.default};
    }
  }

  &:focus-visible {
    outline: 2px solid -webkit-focus-ring-color;
    outline-offset: -2px;
`;

export namespace PillStyles {
  export const Pill = StyledPill;
  export const COUNTRY_FLAG_WIDTH = 18;
  export const COUNTRY_FLAG_HEIGHT = 14;
  export const SQUARE_DIMENSION = 32;
}
